import "./App.css";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import NepalScreen from "./screens/NepalScreen";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import RomaniaScreen from "./screens/RomaniaScreen";
import HomeScreen from "./screens/HomeScreen";
import HonororyConsulScreen from "./screens/HonororyConsulScreen";
import AddHonororyConsulScreen from "./screens/AddHonororyConsulScreen";
import AuthMiddleware from "./routes/middleware/AuthMiddleware";
import LoginScreen from "./screens/LoginScreen";
import EditRomaniaScreen from "./screens/EditRomaniaScreen";
import EditNepalScreen from "./screens/EditNepalScreen";
import EditHonororyConsulScreen from "./screens/EditHonororyConsulScreen";
import VisaScreen from "./screens/VisaScreen";
import EditVisaScreen from "./screens/EditVisaScreen";
import EventsScreen from "./screens/EventsScreen";
import AddEventsScreen from "./screens/AddEventsScreen";
import EditEventsScreen from "./screens/EditEventsScreen";
import NewsScreen from "./screens/NewsScreen";
import AddNewsScreen from "./screens/AddNewsScreen";
import EditNewsScreen from "./screens/EditNewsScreen";
import GalleryScreen from "./screens/GalleryScreen";
import AddGalleryScreen from "./screens/AddGalleryScreen";
import EditGalleryScreen from "./screens/EditGalleryScreen";
import ContactUsScreen from "./screens/ContactUsScreen";
import EditContactUsScreen from "./screens/EditContactUsScreen";

function App() {
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LoginScreen />} />
          <Route
            path="/home"
            element={
              <AuthMiddleware redirectTo="/">
                <HomeScreen />
              </AuthMiddleware>
            }
          />
          <Route
            path="/about-nepal"
            element={
              <AuthMiddleware redirectTo="/">
                <NepalScreen />
              </AuthMiddleware>
            }
          />
          <Route
            path="/edit-nepal/:uuid"
            element={
              <AuthMiddleware redirectTo="/">
                <EditNepalScreen />
              </AuthMiddleware>
            }
          />
          <Route
            path="/about-romania"
            element={
              <AuthMiddleware redirectTo="/">
                <RomaniaScreen />
              </AuthMiddleware>
            }
          />
          <Route
            path="/edit-romania/:uuid"
            element={
              <AuthMiddleware redirectTo="/">
                <EditRomaniaScreen />
              </AuthMiddleware>
            }
          />
          <Route
            path="/honorary-consul"
            element={
              <AuthMiddleware redirectTo="/">
                <HonororyConsulScreen />
              </AuthMiddleware>
            }
          />
          <Route
            path="/add-honorory"
            element={
              <AuthMiddleware redirectTo="/">
                <AddHonororyConsulScreen />
              </AuthMiddleware>
            }
          />
          <Route
            path="/edit-honorory/:uuid"
            element={
              <AuthMiddleware redirectTo="/">
                <EditHonororyConsulScreen />
              </AuthMiddleware>
            }
          />
          <Route
            path="/visa"
            element={
              <AuthMiddleware redirectTo="/">
                <VisaScreen />
              </AuthMiddleware>
            }
          />
          <Route
            path="/edit-visa/:uuid"
            element={
              <AuthMiddleware redirectTo="/">
                <EditVisaScreen />
              </AuthMiddleware>
            }
          />
          <Route
            path="/events"
            element={
              <AuthMiddleware redirectTo="/">
                <EventsScreen />
              </AuthMiddleware>
            }
          />
          <Route
            path="/add-event"
            element={
              <AuthMiddleware redirectTo="/">
                <AddEventsScreen />
              </AuthMiddleware>
            }
          />
          <Route
            path="/edit-event/:uuid"
            element={
              <AuthMiddleware redirectTo="/">
                <EditEventsScreen />
              </AuthMiddleware>
            }
          />
          <Route
            path="/news"
            element={
              <AuthMiddleware redirectTo="/">
                <NewsScreen />
              </AuthMiddleware>
            }
          />
          <Route
            path="/add-news"
            element={
              <AuthMiddleware redirectTo="/">
                <AddNewsScreen />
              </AuthMiddleware>
            }
          />
          <Route
            path="/edit-news/:uuid"
            element={
              <AuthMiddleware redirectTo="/">
                <EditNewsScreen />
              </AuthMiddleware>
            }
          />
          <Route
            path="/gallery"
            element={
              <AuthMiddleware redirectTo="/">
                <GalleryScreen />
              </AuthMiddleware>
            }
          />
          <Route
            path="/add-gallery"
            element={
              <AuthMiddleware redirectTo="/">
                <AddGalleryScreen />
              </AuthMiddleware>
            }
          />
          <Route
            path="/edit-gallery/:uuid"
            element={
              <AuthMiddleware redirectTo="/">
                <EditGalleryScreen />
              </AuthMiddleware>
            }
          />
          <Route
            path="/contact-us"
            element={
              <AuthMiddleware redirectTo="/">
                <ContactUsScreen />
              </AuthMiddleware>
            }
          />
          <Route
            path="/edit-contactUs/:uuid"
            element={
              <AuthMiddleware redirectTo="/">
                <EditContactUsScreen />
              </AuthMiddleware>
            }
          />
        </Routes>
      </BrowserRouter>
      <ToastContainer />
    </>
  );
}

export default App;
